/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import {
  getDatePickerRangeOptions,
  getDatePickerRangeLabel,
} from '../../util/utils';

function DealsListFilters(props) {
  const [showFilters, setShowFilters] = useState(false);
  const [filterParams, setFilterParams] = useState({});
  const ranges = useMemo(() => getDatePickerRangeOptions(), []);

  // whenever a new filter is set, merge it with the current filter
  useEffect(() => {
    setFilterParams(fp => ({ ...fp, ...props.filterParams }));
  }, [props.filterParams]);

  // compute the range, that the date picker can understand, from props and defaults
  const range = useMemo(
    () => ({
      startDate: moment(
        props.filterParams.createdAfterDate || props.options.defaultStart,
      ),
      endDate: moment(
        props.filterParams.createdBeforeDate || props.options.defaultEnd,
      ),
    }),
    [
      props.filterParams.createdAfterDate,
      props.filterParams.createdBeforeDate,
      props.options.defaultEnd,
      props.options.defaultStart,
    ],
  );
  const displayRange = useMemo(
    () =>
      [
        moment(range.startDate).format(props.options.dateFormat),
        moment(range.endDate).format(props.options.dateFormat),
      ].join(' - '),
    [props.options.dateFormat, range.endDate, range.startDate],
  );
  const rangeLabel = useMemo(
    () => getDatePickerRangeLabel(ranges, range.startDate, range.endDate),
    [ranges, range.startDate, range.endDate],
  );

  const changeValue = event => {
    const target = event.target;
    const value = target.value === '' ? null : target.value;
    const name = target.name;
    setFilterParams({ ...filterParams, [name]: value });
  };

  const exportHandler = () => {
    props.onExport(filterParams);
  };

  const submitFilter = event => {
    event.preventDefault();
    props.onFilter(filterParams);
  };

  const applyRange = (event, newRange) => {
    // Change range info
    const newFilterParams = {
      ...filterParams,
      createdAfterDate: moment(newRange.startDate).toISOString(),
      createdBeforeDate: moment(newRange.endDate).toISOString(),
    };
    setFilterParams(newFilterParams);
    props.onFilter(newFilterParams);
  };

  const toggleAdvancedForm = () => setShowFilters(!showFilters);

  return (
    <form
      id="deals-list-filter-form"
      className="deals-list-filter-form"
      name="deals-list-filter-form"
      onSubmit={submitFilter}
    >
      <div>
        <h3>
          <strong>{props.list.total}</strong> Deals from{' '}
          <strong>{rangeLabel}</strong>
          <DateRangePicker
            startDate={range.startDate}
            endDate={range.endDate}
            onApply={applyRange}
            ranges={ranges}
          >
            <button
              type="button"
              className="btn btn-primary margin-left margin-right"
            >
              <i className="glyphicon glyphicon-calendar" />
            </button>
          </DateRangePicker>
          <span className="display-range-label">{displayRange}</span>
          <button
            type="button"
            className="btn btn-primary float-right"
            onClick={exportHandler}
          >
            Export
          </button>
        </h3>
      </div>
      <div className="form-row">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" onClick={toggleAdvancedForm}>
          {showFilters ? 'Hide ' : 'Show '} Search Filters
        </a>
        <div
          className={`deals-filters-form-container ${
            showFilters ? 'show' : ''
          }`}
        >
          <div className="form-group col-3">
            <label htmlFor="dealId">Deal Id</label>
            <input
              type="text"
              className="form-control"
              name="dealId"
              value={filterParams.dealId}
              onChange={changeValue}
            />
          </div>
          <div className="form-group col-3">
            <label htmlFor="dealerId">Dealer</label>
            <input
              type="text"
              className="form-control"
              name="dealerId"
              value={filterParams.dealerId}
              onChange={changeValue}
            />
          </div>
          <div className="form-group col-3">
            <label htmlFor="customerName">Customer Name</label>
            <input
              type="text"
              className="form-control"
              name="customerName"
              value={filterParams.customerName}
              onChange={changeValue}
            />
          </div>
          <div className="form-group col-3">
            <label htmlFor="userName">Sales Person</label>
            <input
              type="text"
              className="form-control"
              name="userName"
              value={filterParams.userName}
              onChange={changeValue}
            />
          </div>
          <div />
          <input
            type="submit"
            value="Search Deals"
            className="btn btn-primary filter-button"
          />
        </div>
      </div>
    </form>
  );
}

DealsListFilters.propTypes = {
  onFilter: PropTypes.func,
  onExport: PropTypes.func,
  options: PropTypes.object,
  list: PropTypes.object,
  filterParams: PropTypes.object,
};

export default DealsListFilters;
